import { MapStatus, STATUS_LOCKED, userRole } from 'constant';
import { userData } from 'pages/Login/selectors';
import { FC, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { siteService } from 'services';
import dayjs from 'dayjs';

import { layoutSelector } from 'containers/Layout/selectors';
import { useQueryParams } from '../../hooks';
import LockStatusStyled, { PropsLockStatus } from './styles';

const LockStatus: FC<PropsLockStatus> = ({
  text,
  date = new Date(),
  roleStatus,
  lockStatus,
  code,
}) => {
  const { roleUser } = useSelector(userData);
  const { buildingId } = useParams<{ buildingId: string }>();
  const query = useQueryParams();

  const currentDayParams = query.get('currentDay') ?? '';
  const { LockStatusData } = useSelector(layoutSelector);
  const [activeStatus, setActiveStatus] = useState<null | number>(null);
  const dateData = useMemo(() => {
    return dayjs((currentDayParams || date) ?? undefined).format('YYYY-MM-DD');
  }, [currentDayParams, date]);

  useEffect(() => {
    buildingId &&
      (async () => {
        try {
          const { data } = await siteService.getSiteActiveStatus({
            building_id: buildingId.toString(),
            date: dateData,
          });
          setActiveStatus(data.status_active);
        } catch (e) {
          console.error(e);
        }
      })();
  }, [buildingId, dateData]);

  return (
    <LockStatusStyled>
      <div className="box-status">
        <div className="text">{text ?? ''}</div>
        <>
          {userRole.BO !== roleUser && (
            <>
              {activeStatus === MapStatus.WORKING && (
                <div
                  className={`${
                    roleStatus && roleStatus.text ? 'status role-status' : 'display-none'
                  } ${roleStatus?.lock && 'lock'}`}
                >
                  {roleStatus?.text ?? ''}
                </div>
              )}
            </>
          )}
          {activeStatus === MapStatus.REST ? (
            <div
              className={`${LockStatusData ? 'status lock-status' : 'display-none'} ${
                LockStatusData?.status_locked === STATUS_LOCKED.true && 'lock'
              }`}
            >
              {LockStatusData?.status_locked === STATUS_LOCKED.true ? '施錠済' : '未施錠'}
            </div>
          ) : (
            <div
              className={`${lockStatus ? 'status lock-status' : 'display-none'} ${
                lockStatus?.lock && 'lock'
              }`}
            >
              {lockStatus?.text ? lockStatus?.text : ''}
            </div>
          )}
        </>
      </div>
      <div className="code">
        工事コード：<span>{code ?? ''}</span>
      </div>
    </LockStatusStyled>
  );
};

export default LockStatus;
